@if (showHeader) {
  <header>
    <div class="container">
      <nav>
        <ul>
          @if (showBackBtn) {
            <li tabindex="0" role="button" (click)="redirectBack()" (keyup.enter)="redirectBack()">
              <img src="assets/images/close-icon.svg" class="close-icon" alt="close-img" />

              <span translate class="back-to-store">COMMON.BACK_TO_STORE</span>
            </li>
          } @else {
            <li></li>
          }

          <li class="logo-container">
            <img src="assets/images/taly-dark-icon.svg" alt="Taly-logo" class="taly-logo" />
          </li>

          <li>
            <div
              tabindex="0"
              role="button"
              class="language"
              (click)="toggleText()"
              (keyup.enter)="toggleText()"
            >
              <img
                [src]="
                  textDirection === 'rtl'
                    ? 'assets/images/en-lang-logo.svg'
                    : 'assets/images/arebic-lang-icon.svg'
                "
                alt="lang"
              />

              <label for="lang" translate>LANGUAGE</label>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </header>
}
